import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { AppPaths } from './app-paths'
import { PathResolveService } from '@core/service/path-resolve.service'
import { ErrorComponent } from './components/error/error.component'

const routes: Routes = [
  {
    path: '',
    redirectTo: AppPaths.register,
    pathMatch: 'full',
  },
  {
    path: AppPaths.register,
    loadChildren: () =>
      import('./components/register/register.module').then((m) => m.RegisterModule),
  },
  {
    path: AppPaths.certificate,
    loadChildren: () =>
      import('./components/certificate-login/certificate-login.module').then(
        (m) => m.CertificateLoginModule
      ),
  },
  {
    path: AppPaths.unlockUser,
    loadChildren: () =>
      import('./components/unlock-user/unlock-user.module').then((m) => m.UnlockUserModule),
  },
  {
    path: AppPaths.deRegister,
    loadChildren: () =>
      import('./components/deregister/deregister.module').then((m) => m.DeRegisterModule),
  },

  // ERROR
  {
    path: 'error',
    component: ErrorComponent,
    data: {
      showHeader: true,
      showSidebar: true,
      showFooter: true,
    },
  },

  // NOT FOUND
  {
    path: '**',
    resolve: {
      path: PathResolveService,
    },
    loadChildren: () =>
      import('./components/not-found/not-found.module').then((m) => m.NotFoundModule),
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
